import { Col } from "reactstrap";
import { JustifiedText, VenueContainer, VenueRow } from "./Venue.stylesheets";
import { useTranslation } from "react-i18next";

export const Venuecontent = () => {
  const { t } = useTranslation();
  return (
    <VenueContainer className="vertical-content">
      <VenueRow className="align-items-center">
        <Col className="p-2 d-block d-lg-none">
          <img
            src="/assets/images/up-estatua.jpg"
            className="img-thumbnail"
            alt="..."
          />
        </Col>
        <Col lg="6">
          <p className="fs-3">{t("LA SEDE DEL CONGRESO PARA EL 2025")} </p>
          <JustifiedText>{t("venueInfo")}</JustifiedText>
          <JustifiedText>
            {t(
              "Más información de la Universidad de Panamá en el siguientes enlace:"
            )}
          </JustifiedText>
          <a
            href="https://www.up.ac.pa/"
            className="btn btn-primary me-1 my-3"
            target="_blank"
            rel="noreferrer"
          >
            {t("UNIVERSIDAD DE PANAMÁ")}
          </a>
        </Col>
        <Col className="p-2 d-none d-lg-block">
          <img
            src="/assets/images/up-estatua.jpg"
            className="img-thumbnail"
            alt="..."
          />
          <p className="fw-light text-end">
            {t("Sede central de la Universidad de Panamá")}
            <br />
            {t("Créditos de la fotografía: Universidad de Panamá")}
          </p>
        </Col>  
      </VenueRow>
    </VenueContainer>
  );
};
